"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandlers = void 0;
var react_1 = require("react");
var useInitData_1 = require("./useInitData");
var useHandlers = function (_a) {
    var sessionItems = _a.sessionItems, dispatch = _a.dispatch, selectedItemsMap = _a.selectedItemsMap, itemsProps = _a.items, listItems = _a.listItems, search = _a.onSearch, placeholder = _a.placeholder, onChange = _a.onChange, allSelectedItems = _a.allSelectedItems, field = _a.field, showApplyButton = _a.showApplyButton, onOpen = _a.onOpen;
    var onSearch = (0, react_1.useCallback)(function (searchStr) { return (!search
        ? itemsProps
            .filter(function (_a) {
            var value = _a.value;
            return value.toLowerCase().includes(searchStr.toLowerCase());
        })
        : search(searchStr)); }, [search, itemsProps]);
    var handlerChange = (0, react_1.useCallback)(function (isChecked, item) {
        var updatedSessionItems = __spreadArray([], sessionItems, true);
        var findedItem = updatedSessionItems.find(function (data) {
            var key = data.key;
            return key === item.key;
        });
        if (isChecked || (!isChecked && !findedItem)) {
            updatedSessionItems = __spreadArray(__spreadArray([], updatedSessionItems, true), [__assign(__assign({}, item), { isChecked: isChecked })], false);
        }
        else {
            updatedSessionItems = updatedSessionItems.map(function (sessionItem) { return (sessionItem.key === item.key
                ? __assign(__assign({}, sessionItem), { isChecked: isChecked }) : sessionItem); });
        }
        dispatch({
            type: 'SET_SESSION_ITEMS',
            value: updatedSessionItems
        });
    }, [sessionItems, dispatch]);
    var handlerAllChange = (0, react_1.useCallback)(function (someVaiable, isChecked) {
        dispatch({
            type: 'SET_SESSION_ITEMS',
            value: listItems.map(function (item) { return (__assign(__assign({}, item), { isChecked: isChecked })); })
        });
    }, [listItems, dispatch]);
    var getValue = (0, react_1.useCallback)(function (activeItems) { return (activeItems.length ? activeItems
        .reduce(function (acc, _a) {
        var value = _a.value;
        return "".concat(acc, ", ").concat(value);
    }, '')
        .slice(1) : placeholder || null); }, [placeholder]);
    var updateSelectedItems = (0, react_1.useCallback)(function () {
        var newSelectedItemsMap = __assign({}, selectedItemsMap);
        sessionItems.forEach(function (_a) {
            var key = _a.key, value = _a.value, isChecked = _a.isChecked;
            if (isChecked && !newSelectedItemsMap[key]) {
                newSelectedItemsMap[key] = { key: key, value: value };
            }
            else if (!isChecked && newSelectedItemsMap[key]) {
                delete newSelectedItemsMap[key];
            }
        });
        var value = Object.keys(newSelectedItemsMap).map(function (key) { return ({
            key: key,
            value: newSelectedItemsMap[key].value
        }); });
        var valueSorted = (0, useInitData_1.sort)(value, 'value');
        dispatch({
            type: 'SET_SELECTED_ITEMS',
            value: valueSorted,
        });
        dispatch({
            type: 'SET_SESSION_ITEMS',
            value: []
        });
    }, [sessionItems, dispatch, selectedItemsMap]);
    var handlerOnChange = (0, react_1.useCallback)(function () {
        if (onChange) {
            onChange({
                target: {
                    value: __spreadArray([], allSelectedItems, true),
                    name: field
                }
            });
        }
    }, [onChange, field, allSelectedItems]);
    var handlerClose = (0, react_1.useCallback)(function () {
        if (!showApplyButton) {
            updateSelectedItems();
            handlerOnChange();
        }
        if (showApplyButton) {
            dispatch({
                type: 'SET_SESSION_ITEMS',
                value: []
            });
        }
        dispatch({
            type: 'SET_SEARCH',
            value: ''
        });
        dispatch({
            type: 'SET_OPEN',
            value: false
        });
    }, [updateSelectedItems, dispatch, handlerOnChange, showApplyButton]);
    var handlerApply = (0, react_1.useCallback)(function () {
        updateSelectedItems();
        handlerOnChange();
        dispatch({
            type: 'SET_SEARCH',
            value: ''
        });
        dispatch({
            type: 'SET_OPEN',
            value: false
        });
    }, [updateSelectedItems, dispatch, handlerOnChange]);
    // @ts-ignore
    var handlerSearch = (0, react_1.useCallback)(function (_a) {
        var _b = _a.target, target = _b === void 0 ? { value: '' } : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        dispatch({
                            type: 'LOAD_SEARCH',
                            value: { isLoading: 'load' }
                        });
                        updateSelectedItems();
                        return [4 /*yield*/, onSearch(target.value)];
                    case 1:
                        result = _c.sent();
                        dispatch({
                            type: 'SUCCESS_LOAD_SEARCH',
                            value: { items: result, search: target.value }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _c.sent();
                        dispatch({
                            type: 'ERROR_LOAD_SEARCH',
                            value: { items: [], search: target.value }
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [dispatch, updateSelectedItems, onSearch]);
    var handlerOpen = (0, react_1.useCallback)(function (event) {
        // @ts-ignore
        handlerSearch({ target: { value: '' } });
        dispatch({
            type: 'SET_OPEN',
            value: true
        });
        if (onOpen) {
            onOpen(event);
        }
    }, [
        dispatch,
        onOpen,
        handlerSearch
    ]);
    return {
        handlerSearch: handlerSearch,
        handlerChange: handlerChange,
        getValue: getValue,
        handlerClose: handlerClose,
        handlerOpen: handlerOpen,
        handlerAllChange: handlerAllChange,
        handlerApply: handlerApply
    };
};
exports.useHandlers = useHandlers;
